// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Cp6H","tab":"ProcedureTabs_tab__pl9IX"};